import React from 'react';
import './HealthcarePage.css'; // Reuse styling or create HealthcarePage.css
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const HealthcarePage = () => {
  const navigate = useNavigate();
  const handleViewProjects = () => {
    navigate('/#contact'); // Adjust if needed
  };

  return (
    <div className="healthcare-page">
      <Helmet>
        <title>Healthcare | AnalyticaNova</title>
        <meta name="description" content="Learn about AnalyticaNova’s mission to empower data-driven decisions in healthcare." />
      </Helmet>

      <header className="healthcare-nav-bar">
        <nav className="healthcare-nav-links">
          <Link to="/" className="healthcare-nav-link">Home</Link>
          <div className="healthcare-dropdown">
            <span className="healthcare-dropbtn">Verticals</span>
            <div className="healthcare-dropdown-content">
              <Link to="/construction">Construction</Link>
              <Link to="/healthcare">Healthcare</Link>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="hero-split">
        <div className="hero-content">
          <h1>India's Premier Platform for Healthcare Market Intelligence</h1>
          <p>Empowering stakeholders with data-driven insights across hospitals, diagnostics, and medtech infrastructure.</p>
          <button className="cta-button" onClick={handleViewProjects}>Explore Opportunities</button>
        </div>
        <div className="hero-image">
          <img src="/Dashboard.png" alt="Healthcare Dashboard" />
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <h2>Our Services</h2>
        <div className="service-cards">
          <div className="card">
            <h3>Track Hospital & Diagnostic Expansion</h3>
            <p>Identify new investments, upgrades, and greenfield projects across India’s healthcare landscape.</p>
          </div>
          <div className="card">
            <h3>Assess Regional Demand & Capacity</h3>
            <p>Use granular data to evaluate underserved areas and emerging healthcare hubs.</p>
          </div>
          <div className="card">
            <h3>Engage with Healthcare Decision Makers</h3>
            <p>Connect with hospital administrators, consultants, and procurement heads.</p>
          </div>
          <div className="card">
            <h3>Accelerate Medtech & Pharma Outreach</h3>
            <p>Target the right institutions with tailored sales and marketing strategies.</p>
          </div>
          <div className="card">
            <h3>Benchmark Healthcare Infrastructure</h3>
            <p>Compare facility sizes, specialties, and investment trends across regions.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HealthcarePage;